import './index.css'
import React from 'react'
import type { CSSProperties } from 'react'
/**
 * @deprecated Use `Heading` from `components/ds` instead.
 * @see {@link components/ds/Heading}
 * @migration
 * - Replace `<Heading size={N}>` with `<Heading size="N">` from components/ds
 * - Size mapping (legacy → DS):
 *   - size={900} or size="900" → size="9"
 *   - size={800} or size="800" → size="8"
 *   - size={700} or size="700" → size="7"
 *   - size={600} or size="600" → size="6"
 *   - size={500} or size="500" → size="5"
 *   - size={400} or size="400" → size="4"
 *   - size={300} or size="300" → size="3"
 *   - size={200} or size="200" → size="2"
 *   - size={100} or size="100" → size="1"
 * - textAlign → use `align` prop on DS Heading
 * - DS Heading supports `as` prop to change the rendered element (h1-h6)
 *
 * A heading component with configurable size and text alignment
 * @param size - The heading size as a number or string (defaults to 700)
 * @param children - The heading content to display
 * @param textAlign - The text alignment CSS property
 * @returns An h1 element with size-based styling and optional text alignment
 */
const Heading = ({
  size = 700,
  children,
  textAlign,
}: {
  size?: number | string
  children: React.ReactNode
  textAlign?: CSSProperties['textAlign']
}) => {
  const st: CSSProperties = {
    textAlign,
  }
  return (
    <h1 className={`Heading Heading--${size}`} style={st}>
      {children}
    </h1>
  )
}

export default React.memo(Heading)
